import { Note } from "../../../../../src/classes";
import { userInfo } from "../../user";

export const alternateStringsInfo = new Note({
  note: "Altenate strings need to be capitalized to copy and paste them into JEPP! See example in the note below",
  title: "For Alternate Strings",
  userInfo,
});
